import React from 'react'
import PropTypes from 'prop-types'
import { track } from '@amplitude/analytics-browser';
import './PopupPersonalAccount.css';

const PopupPersonalAccount = ({ handleClose }) => {
   const handleAmplitudeEvent = () => {
        track("BRIZ TV Sign Up");
        handleClose()
    }
  return (
    <div id="popup__personal-account-wrap">
      <div className="popup__personal-account">
        <h1 className="popup__personal-account-title">
          <span>По техническим причинам,</span>
          <br /> <span>приложение BRIZ IPTV прекращает поддержку.</span>
        </h1>
        <p className="popup__personal-account-text">
          <span>Пожалуйста, зарегистрируйтесь в новом приложении BRIZ TV</span>{" "}
          <br />{" "}
          <span>
            для получения обновлений и сохранения стабильной работы приложения.
          </span>
        </p>
        <a
          onClick={handleAmplitudeEvent}
          className="popup__personal-account-link"
          href="https://my.briz.ua/brizTV"
          target="_blank"
          rel="noopener noreferrer"
        >
          Зарегистрироваться
        </a>
        <button
          onClick={handleClose}
          type="button"
          className="popup__personal-account-btn-close"
        >
          <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.59998 0.000159678L15.9998 14.6594L14.3999 16.2883L0 1.62897L1.59998 0.000159678Z"
              fill="#3D3D3D"
            />
            <path
              d="M0.000170878 14.6593L14.4 0L16 1.62881L1.60016 16.2881L0.000170878 14.6593Z"
              fill="#3D3D3D"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}

PopupPersonalAccount.propTypes = {
    handleClose: PropTypes.func
}

export default PopupPersonalAccount



// WEBPACK FOOTER //
// ./src/components/PopupPersonalAccount.js